// extracted by mini-css-extract-plugin
export default {"title":"AppModal_title__LL8rz","content":"AppModal_content__tQDts","footer":"AppModal_footer__ztBCF","footer_button":"AppModal_footer_button__NuknH"};